import { formatNumber, formatPercent } from "utils/formatNumber";
import { cva } from "../../../../styled-system/css/cva";
import { css } from "../../../../styled-system/css";
import { Grid } from "../../../../styled-system/jsx";

interface Props {
  selected?: boolean;
  shelf: {
    name: string;
    brand_name: string;
    searches: unknown[];
    stats: { position_avg?: number; share_of_shelf: number };
  };
  onClick?: () => void;
}

const ShelfSummaryTile = ({ selected, shelf, onClick }: Props) => {
  return (
    <div
      onClick={onClick}
      className={cva({
        base: { borderRadius: "card", padding: "medium", backgroundColor: "white" },
        variants: {
          selected: {
            true: {
              color: "white",
              backgroundColor: "trellisPalette.3",
            },
          },
        },
      })({ selected })}
    >
      <h4
        className={css({
          margin: 0,
          color: "inherit",
          fontWeight: "bold",
        })}
      >
        {shelf.name}
      </h4>
      <Grid gap="xsmall" fontSize="medium" columns={2}>
        <span>Home Brand</span>
        <span className={css({ justifySelf: "end" })}>{shelf.brand_name}</span>
        <span>
          {shelf.searches.length} Search{shelf.searches.length === 1 ? "" : "es"}
        </span>
        <span />
        <span>Share of Shelf</span>
        <span className={css({ justifySelf: "end" })}>{formatPercent(shelf.stats.share_of_shelf / 100, 2)}</span>
        <span>Average Rank</span>
        <span className={css({ justifySelf: "end" })}>
          {formatNumber(shelf.stats.position_avg, { decimalPlaces: 2 })}
        </span>
      </Grid>
    </div>
  );
};

export default ShelfSummaryTile;
